import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=75dc8974&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=ts&"
export * from "./refund.vue?vue&type=script&lang=ts&"
import style0 from "./refund.vue?vue&type=style&index=0&id=75dc8974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc8974",
  null
  
)

export default component.exports